/**
 * Reveal mobile navigation
 */

export default function revealMobileNav(el, props) {
  const mastheadEl = el;
  const navEl = el.querySelector(props.navEl);
  const navToggleEl = el.querySelector(props.navToggleEl);
  const navDropdownEl = el.querySelectorAll(props.navDropdownEl);
  const navToggleActiveClass = props.navToggleActiveClass;
  const transitionClass = "masthead--transition";

  // Offset masthead element by the height of the nav element
  function toggleNavMenu(el) {
    let navHeight = navEl.clientHeight;
    if (el === navToggleEl) {
      mastheadEl.classList.add(transitionClass);
      if (el.classList.contains(navToggleActiveClass)) {
        return mastheadEl.style.setProperty("padding-top", `${navHeight}px`);
      } else {
        return mastheadEl.style.setProperty("padding-top", "0");
      }
    } else {
      mastheadEl.classList.remove(transitionClass);
      return mastheadEl.style.setProperty("padding-top", `${navHeight}px`);
    }
  }

  // Calculate offset when toggling nav element and child dropdown elements
  navToggleEl.addEventListener("click", function() {
    toggleNavMenu(navToggleEl);
  });
  let i;
  for (i = 0; i < navDropdownEl.length; ++i) {
    navDropdownEl[i].addEventListener("click", function() {
      toggleNavMenu(navDropdownEl[i]);
    });
  }
}
